export enum PriceConditionType {
  HOURS_FROM_TO = 'hours',
  NUMBER_OF_CHEAPEST_PERIODS = 'cheapestPeriods',
  PRICE_GREATER_OR_EQUAL = 'priceGreater',
  PRICE_LESSER_OR_EQUAL = 'priceLesser',
}